/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui'

import { HeadingStyled, HeadingBlockStyled, HeadingCtaStyled } from './styles'
import Button from './../../atoms/Button'
import { HeadingProps } from './types'

const Heading: React.FC<HeadingProps> = ({ isMain, title, subtitle, desc, url, urlText, urlIsExternal }) => {
  return (
    <HeadingStyled>
      {isMain ? (
        <HeadingBlockStyled
          as="h2"
          sx={{
            variant: 'headingRaleway4',
            fontFamily: 'secondary',
            fontWeight: ['bold', 'extrabold'],
            marginBottom: ['8px', '20px']
          }}
        >
          {title}
        </HeadingBlockStyled>
      ) : (
        <HeadingBlockStyled
          as="h2"
          sx={{
            variant: 'headingRaleway2',
            fontFamily: 'secondary',
            fontWeight: 'bold',
            marginBottom: ['24px', '32px']
          }}
        >
          {title}
        </HeadingBlockStyled>
      )}
      {subtitle && (
        <HeadingBlockStyled
          as="p"
          sx={{
            variant: 'headingMontserrat3',
            marginBottom: ['28px', '40px']
          }}
        >
          {subtitle}
        </HeadingBlockStyled>
      )}
      {desc && (
        <HeadingBlockStyled
          as="p"
          sx={{
            variant: 'bodyMontserrat5',
            fontFamily: 'primary',
            marginBottom: ['40px', '46px']
          }}
        >
          {desc}
        </HeadingBlockStyled>
      )}
      {url && urlText ? (
        <HeadingCtaStyled>
          <Button variant="withArrow" {...{ url }} urlText={urlText} urlIsExternal={urlIsExternal} />
        </HeadingCtaStyled>
      ) : null}
    </HeadingStyled>
  )
}

export default Heading
